import { Button, Typography, useTheme } from "@mui/material";

import { router } from "@inertiajs/react";
import { bindHover } from "material-ui-popup-state";
import { useCallback } from "react";
import { IPage } from "./types";
import { useDesktopButtonSx } from "./useDesktopButtonSx";

interface IProps {
  page: IPage;
}
interface IMenuProps extends ReturnType<typeof bindHover> {
  page: IPage;
}

const HeaderButton = ({ page, ...boundHover }: IProps | IMenuProps) => {
  const theme = useTheme();
  const getButtonDesktopPageSX = useDesktopButtonSx();

  const handleNavigate = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (!page.children.length) {
        e.preventDefault();
        e.stopPropagation();
        router.visit(page.routes.main);
      }
    },
    [page.children.length, page.routes.main],
  );

  const isExternalLink = page.routes.main.startsWith("http");
  const linkProps = isExternalLink
    ? {
        href: page.routes.main,
        target: "_blank",
        rel: "noopener noreferrer",
      }
    : undefined;

  return (
    <Button
      disabled={page.disabled}
      sx={getButtonDesktopPageSX(page, theme)}
      size="large"
      disableRipple
      onClick={isExternalLink ? undefined : handleNavigate}
      {...linkProps}
      {...boundHover}
    >
      <Typography
        component={"div"}
        variant="caption"
        sx={{
          color: page.isBlue
            ? theme.palette.common.white
            : theme.palette.secondary.dark,
          opacity: page.disabled ? 0.3 : 1,
          textAlign: "center",
          fontFamily: "Lexend",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "18px",
        }}
      >
        {page.name({})}
      </Typography>
    </Button>
  );
};

HeaderButton.displayName = "HeaderButton";
export default HeaderButton;
